import { useState } from "react";

import type { Session } from "../auth";

interface Props {
  session: Session;
  onDone: () => void;
  onCancel: () => void;
}

export function ChangePassword({ session, onDone, onCancel }: Props) {
  const [oldPw, setOldPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [newPw2, setNewPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    if (newPw.length < 12) {
      setError("Nowe hasło musi mieć co najmniej 12 znaków.");
      return;
    }
    if (newPw !== newPw2) {
      setError("Nowe hasła nie zgadzają się.");
      return;
    }
    if (oldPw === newPw) {
      setError("Nowe hasło musi być inne niż stare.");
      return;
    }
    setBusy(true);
    const oldCopy = oldPw;
    const newCopy = newPw;
    setOldPw("");
    setNewPw("");
    setNewPw2("");
    try {
      await session.changePassword(oldCopy, newCopy);
      onDone();
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <div className="header">
        <button className="back-btn" onClick={onCancel} aria-label="Anuluj">
          ‹ Anuluj
        </button>
        <h1>Zmień hasło główne</h1>
      </div>

      <form className="main" onSubmit={submit}>
        <div className="muted" style={{ marginBottom: 16, fontSize: 14, lineHeight: 1.5 }}>
          Wpisy w sejfie zostają nienaruszone — zmienia się tylko klucz szyfrujący.
          Po zmianie wszystkie sesje (inne urządzenia, biometria) zostaną unieważnione
          i trzeba się będzie zalogować ponownie.
        </div>

        <div className="field">
          <label htmlFor="old">Stare hasło</label>
          <input
            id="old"
            type="password"
            value={oldPw}
            onChange={(e) => setOldPw(e.target.value)}
            autoComplete="current-password"
            required
            autoFocus
          />
        </div>

        <div className="field">
          <label htmlFor="new">Nowe hasło (min. 12 znaków)</label>
          <input
            id="new"
            type="password"
            value={newPw}
            onChange={(e) => setNewPw(e.target.value)}
            autoComplete="new-password"
            required
          />
        </div>

        <div className="field">
          <label htmlFor="new2">Powtórz nowe hasło</label>
          <input
            id="new2"
            type="password"
            value={newPw2}
            onChange={(e) => setNewPw2(e.target.value)}
            autoComplete="new-password"
            required
          />
        </div>

        {error && <div className="error">{error}</div>}

        <button type="submit" className="btn-block" disabled={busy}>
          {busy ? "Zmieniam…" : "Zmień hasło"}
        </button>
      </form>
    </>
  );
}
